import { render, staticRenderFns } from "./preset-search-most-stable.vue?vue&type=template&id=4dd21d06&"
import script from "./preset-search-most-stable.vue?vue&type=script&lang=js&"
export * from "./preset-search-most-stable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports